import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Selectors } from 'store/root-reducer';
import { SearchesCommon } from '../searches.common';
import { InternetSearchDetailComponent } from '../components/searches-detail/internet-search-detail/internet-search-detail.component';
var SearchesInternetComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SearchesInternetComponent, _super);
    function SearchesInternetComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayedColumns = [];
        _this.isFilterOn = false;
        _this.isNlpEnabled = false;
        return _this;
    }
    SearchesInternetComponent.prototype.ngOnInit = function () {
        this.getBillableInfo();
    };
    /**
     * Get subscription information from state to decide whether NLP is enabled
     * @method getBillableInfo
     */
    SearchesInternetComponent.prototype.getBillableInfo = function () {
        var _this = this;
        this.store.select(Selectors.billable.getNLP)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (nlpEnabled) {
            _this.isNlpEnabled = nlpEnabled ? nlpEnabled.display : false;
            _this.setTableColumns();
        });
    };
    /**
     * Set different table columns based on whether NLP is enabled
     * @method setTableColumns
     */
    SearchesInternetComponent.prototype.setTableColumns = function () {
        if (this.isNlpEnabled) {
            // Set the column name as nlpJson.sentiment.score to enable sorting
            this.displayedColumns = ['checkbox', 'linkDetail', 'mostRelevantName', 'nlpJson.sentiment.score', 'actions', 'matched'];
        }
        else {
            this.displayedColumns = ['checkbox', 'linkDetail', 'matched'];
        }
    };
    /**
     * Open NLP details popup window
     * @method selectDetail
     */
    SearchesInternetComponent.prototype.selectDetail = function (item) {
        this.dialogRefInternetSearch = this.dialog.open(InternetSearchDetailComponent, {
            data: item.nlpJson,
            autoFocus: false,
            width: '1300px',
            panelClass: 'internect-search-detail-dialog'
        });
    };
    return SearchesInternetComponent;
}(SearchesCommon));
export { SearchesInternetComponent };
